import React from "react";
import { Link } from "react-router-dom";

import { quickLinks, legal } from "../../utils/footer_links";
import { sendToCountries } from "../../utils/countries";

const half = Math.ceil(sendToCountries.length / 2);

const firstHalf = sendToCountries.slice(0, half);
const secondHalf = sendToCountries.slice(-half);

function FooterLinks(props) {
  return (
    <div className="col-12 col-md-7 col-lg-8">
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="">
            <div className="row">
              <div className="col-6 col-sm-12">
                <div className="">
                  <h5 className="fs-5 mb-2">Quick Links</h5>
                  <ul className="list-unstyled">
                    {quickLinks.map((ql) => (
                      <li key={ql.title} className="mb-1">
                        <Link
                          to={ql.url}
                          className="text-decoration-none text-dark"
                        >
                          {ql.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-6 col-sm-12">
                <div className="">
                  <h5 className="fs-5 mb-2">Legal</h5>
                  <ul className="list-unstyled">
                    {legal.map((lg) => (
                      <li key={lg.title} className="mb-1">
                        <Link
                          to={lg.url}
                          className="text-decoration-none text-dark"
                        >
                          {lg.title}
                        </Link>
                      </li>
                    ))}
                    <li className="mb-1">
                      <a
                        className="text-dark text-decoration-none"
                        href="mailto: careers@tanaad.com"
                      >
                        careers@tanaad.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="">
            <div className="row">
              <div className="col-6 col-sm-12">
                <div className="">
                  <div className="">
                    <h5 className="fs-5 mb-1">Send Money to</h5>
                    <ul className="list-unstyled">
                      {firstHalf.map((sc, index) => (
                        <li key={index} className="mb-1">
                          <Link
                            to="#"
                            className="text-decoration-none text-dark"
                          >
                            {sc.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-6 col-sm-12">
                <div className="">
                  <ul className="list-unstyled">
                    {secondHalf.map((sc, index) => (
                      <li key={index} className="mb-1">
                        <Link to="#" className="text-decoration-none text-dark">
                          {sc.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterLinks;
